import { useAuth } from "@/core/components/auth/store/auth";
import {
  FunctionComponent,
  createContext,
  useCallback,
  useContext,
} from "react";
import { useLocation } from "react-router-dom";
import {
  generateTrackData,
  sendTrackData,
  sendUserIdentifyData,
} from "../../utils/track-data";
import { AnalyticsContextProps, AnalyticsProviderProps } from "./segment.types";

const AnalyticsContext = createContext({} as AnalyticsContextProps);

export const AnalyticsProvider: FunctionComponent<AnalyticsProviderProps> = ({
  children,
}) => {
  const { userInfo } = useAuth();
  const { pathname } = useLocation();

  const track = useCallback<AnalyticsContextProps["track"]>(
    (eventName, data) => {
      const trackData = generateTrackData({
        ...data,
        userId: userInfo?.user?.id,
        role: userInfo?.profile?.role?.join(", "),
        value: {
          ...data?.value,
        },
        urlPage: pathname,
        origin: "myoffice",
      });

      sendUserIdentifyData(userInfo);

      sendTrackData({ eventName, ...trackData });
    },
    [userInfo, pathname],
  );

  return (
    <AnalyticsContext.Provider
      value={{
        track,
      }}
    >
      {children}
    </AnalyticsContext.Provider>
  );
};

export const useAnalytics = () => useContext(AnalyticsContext);
